import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { ArrowRightCircle, ArrowRoundedLeft } from '@aok/icon-functional'
import { ContextHeadline } from '@aok/text-elements'
import { Link, JumpLink } from '@aok/ui-elements'

import AllroundContainer from '../../_layouts/AllroundContainer'

import defaultProps from '../../../utils/propTypes/defaultProps'

const T009 = ({ topicUrl, articleLinks }) => {
  const [showAllLinks, setShowAllLinks] = useState(false)

  return (
    <AllroundContainer dataTrackingName="T009" className="t009">
      <div className="mx-auto 1000:w-2/3 1280:w-800">
        <ContextHeadline
          text="Nächster Artikel"
          className="font-buenos-aires font-semibold text-005e3f text-28 leading-36 1280:text-32 1280:leading-44"
        />

        <ul className="mt-16 w-full 600:mt-24">
          {articleLinks.map((link, index) => {
            return (
              <li
                className={`group
                  ${index === 0 || (index > 0 && showAllLinks) ? 'block' : 'hidden'}
                `}
                key={index}
              >
                <a
                  href={link.url}
                  className={`flex justify-between items-center
                    font-semibold text-16 leading-24 text-293033 group-hover:text-18ab42
                    border-b-2 border-dfe3e6
                    focus-visible:outline-none focus-visible:shadow-greenOutline2
                    p-16 cursor-pointer
                    ${index === 0 ? 'border-t-2' : ''}`}
                >
                  {link.title}
                  <ArrowRightCircle className="text-005e3f group-hover:text-18ab42 ml-16 w-24 h-24 fill-current shrink-0" />
                </a>
              </li>
            )
          })}
        </ul>

        <div className="flex justify-between w-full mt-24 1000:mt-32">
          <Link
            href={topicUrl}
            theme="secondary"
            iconPosition="left"
            title={
              <>
                <span className="hidden 600:inline">zurück&nbsp;</span>
                <span>zum Thema</span>
              </>
            }
            icon={<ArrowRoundedLeft className="w-16 h-16 fill-current mr-4" />}
          />

          <JumpLink
            iconPosition="right"
            arrowDirection="down"
            title="Alle Artikel anzeigen"
            onClick={() => setShowAllLinks(!showAllLinks)}
            className={`${showAllLinks ? 'hidden' : 'block'} showItems `}
          />
        </div>
      </div>
    </AllroundContainer>
  )
}

T009.propTypes = {
  topicUrl: PropTypes.string,
  articleLinks: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    })
  ),
}

T009.defaultProps = {
  topicUrl: defaultProps.URL,
  articleLinks: [
    {
      title: defaultProps.TITLE,
      url: defaultProps.URL,
    },
  ],
}

export default T009
